(function(_s) {
    _s.fn.videoModule = function() {
        return this.each(el => {
            const _self = _s(el);
            const _videoEmbed = _self.find('.video-embed');
            const _playBtn = _self.find('.play-btn');
            
            if (_videoEmbed.length) {
                const videoProvider = _videoEmbed.attr('data-video-provider');
                const videoUrl = _videoEmbed.attr('data-video-url');
                const videoId = _videoEmbed.attr('data-video-id');
                const autoplay = _videoEmbed.attr('data-autoplay') === '1';
                const controls = _videoEmbed.attr('data-controls') === '1';
                
                const embedVideo = () => {
                    let embedCode = '';
                    
                    switch(videoProvider) {
                        case 'streamAMG':
                            embedCode = `<iframe src="https://streamAMG.com/embed/${videoId}?autoplay=${autoplay ? 1 : 0}&controls=${controls ? 1 : 0}" frameborder="0" allowfullscreen></iframe>`;
                            break;
                        case 'youtube':
                            const ytVideoId = videoUrl.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i)[1];
                            embedCode = `<iframe src="https://www.youtube.com/embed/${ytVideoId}?autoplay=${autoplay ? 1 : 0}&controls=${controls ? 1 : 0}" frameborder="0" allowfullscreen></iframe>`;
                            break;
                        case 'cortexMedia':
                            embedCode = `<iframe src="https://cortexmedia.com/embed/${videoId}?autoplay=${autoplay ? 1 : 0}&controls=${controls ? 1 : 0}" frameborder="0" allowfullscreen></iframe>`;
                            break;
                    }
                    
                    _videoEmbed.html(embedCode);
                };
                
                if (autoplay) {
                    embedVideo();
                } else {
                    _playBtn.on('click', () => {
                        embedVideo();
                    });
                }
            }
        });
    };
    
    _s(document).ready(() => {
        _s('.video-module').videoModule();
    });
})(window._s);